<template>
    <div>
       <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="交易类型">
                <el-select v-model="formInline.tradeType" clearable  placeholder="交易类型">
                    <el-option label="支付" value="1"></el-option>
                    <el-option label="退款" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据来源">
                <el-select v-model="formInline.dataSource" clearable  placeholder="数据来源">
                    <el-option label="招商平台" value="cmbpay"></el-option>
                    <el-option label="微信平台" value="wxpay"></el-option>
                    <el-option label="支付宝平台" value="alipay"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期">
                <el-date-picker
                        v-model=formInline.createTime
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
           <el-form-item>
               <el-button type="success" @click="getOrderBillList">查询</el-button>
               <!-- <el-button type="success" @click="orderBill">对账</el-button>
               <el-button type="success" @click="readCsv">解析</el-button>-->
               <el-button type="success" @click="billResult">对账</el-button>
           </el-form-item>
       </el-form>
       <el-table :data="orderBillList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                 v-show="!showDialog">
           <el-table-column type="index" label="序号" width="50"></el-table-column>
           <el-table-column prop="tradeNo" label="交易号" width="220"></el-table-column>
           <el-table-column prop="billResult" label="对账结果" :formatter="billResultName" width="410"></el-table-column>
           <el-table-column prop="tradeType" label="交易类型" :formatter="tradeTypeName" width="230"></el-table-column>
           <el-table-column prop="dataSource" label="数据来源" :formatter="dataSourceName" width="220"></el-table-column>
           <el-table-column prop="createTime" label="创建时间" width="520"></el-table-column>
           <el-table-column label="操作" fixed="right" width="290">
               <template slot-scope="scope">
                   <el-button type="warning" size="mini" @click="handleDelete(scope.row)">删除</el-button>
               </template>
           </el-table-column>
       </el-table>
       <div class="pagination-wrap" v-show="!showDialog">
           <el-pagination
                   background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="formInline.currentPage"
                   :page-sizes="GCONFIG.pageSizes"
                   :page-size="formInline.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="formInline.recordsTotal">
           </el-pagination>
       </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getOrderBillInfo,orderBill,readCsv,billResult,deletebillResult} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    createTime:"",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                loading: true,
                orderBillList:[]
            }
        },
        //挂载时候执行
        mounted(){
            this.getOrderBillList();
        },
        methods: {
            getOrderBillList(){
                this.loading = true;
                getOrderBillInfo(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.orderBillList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            orderBill(){
                orderBill(this.formInline).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                            this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            readCsv(){
                readCsv(this.formInline).then((res) => {
                   if(res.data.status==200){
                       this.$message({
                           showClose: true,
                           message: '成功',
                           type: 'success'
                       });
                   }else{
                           this.$message({
                           showClose: true,
                           message: res.data.message,
                           type: 'error'
                       });
                   }
                });
            },

            billResult(){
                billResult(this.formInline).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                            this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            //删除事件
            handleDelete(row){
                this.$confirm('删除此数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deletebillResult({tradeNo:row.tradeNo}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getOrderBillList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            billResultName: function (row, column) {
                return row.billResult == 1 ? '自身无第三方有' : row.billResult == 2 ? '自身有第三方无' : '未知';
            },
            dataSourceName: function (row, column) {
                return row.dataSource == "cmbpay" ? '招商平台' : row.dataSource == "wxpay" ? '微信平台' : row.dataSource == "alipay" ? '支付宝平台' : '未知平台';
            },
            tradeTypeName: function (row, column) {
                return row.tradeType == 1 ? '支付' : row.tradeType == 2 ? '退款' : '未知';
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getOrderBillList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getOrderBillList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/bill/orderBill.vue